<template>
  <div class="category-filter">
    <div class="filter-type buttons" >
      <div class="arrow left d-none d-md-block">
        <button @click="move($refs.categories, 'left')" class="btn btn-default nav-prev">&lt;&lt;</button>
      </div>
      <div class="bench">
        <div class="d-row" ref="categories" style="transform: translateX(0px)">
          <button
            v-for="category in notEmptyCategoryList"
            :style="{
              'background': printBackground(category)
            }"
            @click="filter(category.id, 'category')"
            class="btn btn-default">
            {{ category.name }}
          </button>
        </div>
      </div>
      <div class="arrow right d-none d-md-block">
        <button @click="move($refs.categories, 'right')" class="btn btn-default nav-next">&gt;&gt;</button>
      </div>
    </div>
    <!-- /.filter-type -->

    <div class="list-favorites">
      <button class="btn btn-default d-none d-md-block nav-prev">&lt;&lt;</button>
      <button 
        class="btn btn-default" 
        :class="{
          'btn--active': (currentScreen && currentScreen.id === 'all' )
        }" 
        @click="filter('all', 'category')" 
        v-translate
      >all articles</button>
      <button
        v-for="favorite in favorites"
        @click="filter(favorite.id, 'favorite')"
        :style="{
          'background': (currentScreen.type == 'favorite'
                          && currentScreen.id === favorite.id)
                            ? 'linear-gradient(to top, #A4CD39 0%, #DAE7A4 100%)'
                            : ''
        }"
        class="btn btn-default">
        {{ favorite.name }}
      </button>
      <button class="btn btn-default ml-auto d-none d-md-block" v-translate>Specials</button>
      <button class="btn btn-default d-none d-md-block nav-next">&gt;&gt;</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategoryFilter',
  data() {
    return {};
  },
  computed: {
    categories() {
      const articles = this.getArray('articles');
      console.log('touched');
      return this
              .getArray('categories')
              .sort((a, b) => a.indexNumber - b.indexNumber)
              .filter(category => !category.parentId)
    },
    notEmptyCategoryList() {
      const notEmptyCategoryList = [];
      this.categories.forEach(category => {
        const articles = this
                          .$store
                          .getters
                          .getScreenArticles({
                            type: 'category',
                            id: category.id
                          });
        if(articles.length > 0) {
          notEmptyCategoryList.push(category);
        }
      })
      return notEmptyCategoryList;
    },
    favorites() { return this.getArray('favorites').sort((a, b) => a.indexNumber - b.indexNumber)},
    currentScreen() { return this.getMap('currentScreen', true)}
  },
  methods: {
    filter(id, type) {
      this.$store.state.article.currentScreen = {
        id,
        type,
      };
    },

    move(component, direction) {
      let totalWidth = 0;
      component.childNodes.forEach(child => {
        if(child.clientWidth) {
        totalWidth += child.clientWidth;
        }
      });
      const benchTranslate = 1 * component.style.transform.replace('translateX(', '').replace('px)', '');
      const coveredDistance = component.clientWidth - benchTranslate;

      if(totalWidth > coveredDistance && direction == 'right') {
        const newTranslate = benchTranslate - ((totalWidth - coveredDistance) > 120 ? 120 : (totalWidth - coveredDistance));
        component.style.transform = 'translateX(' + newTranslate + 'px)';
      }
      if(benchTranslate < 0 && direction == 'left') {
        const newTranslate = benchTranslate < -120 ? (benchTranslate + 120) : 0;
        component.style.transform = 'translateX(' + newTranslate + 'px)';
      }

    },
    printBackground(category) {
      if(!this.currentScreen.id || !category || this.currentScreen.type != 'category') return '';
      const cat = this.getObject(this.currentScreen.id, 'categories');
      if(!cat) return '';
      const ancestor = this.getAncestor(cat);
      if(ancestor.id !== category.id) return '';
      return this.$store.getters.printCategoryColor(category);
    },
    getAncestor(category) {
      if(!category.parentId) return category;
      const parent = this.getObject(category.parentId, 'categories');
      if(!parent) return category;
      return this.getAncestor(parent);
    }
  }
};
</script>
